import {defineRegistryAttribute, defineRenderAttribute} from '@acng/frontend-stargazer';
import {inject} from 'acng/core/service/ng';
import {removeNode, toggleClass} from '@acng/frontend-bounty';
import {WatchGroup} from '@acng/frontend-relativity';
import {ctxGameSession} from '../context/session.js';
import {ctxAmateur} from 'acng/amateurPool/context/amateur.js';
import {IS, guard} from '@acng/frontend-rubicon';
import {hide, show} from '@acng/frontend-bounty/style/element.js';

defineRegistryAttribute('data-sedcard-game', (name) => {
  const watch = WatchGroup(`[${name}]`, ctxAmateur, ctxGameSession);

  defineRenderAttribute(
    name,
    () => (element) =>
      watch(element, (element, [amateur]) => {
        ASSERT: guard(element, IS(HTMLElement));

        if (!amateur || !inject('user').hasGames() || !amateur.hasGames()) {
          hide(element);
          return;
        }

        show(element);

        const gameState = amateur?.getGame()?.getState();
        if (gameState) {
          for (const key in gameState) {
            // @ts-expect-error
            toggleClass(element, key, gameState[key]);
          }
        }
      })
  );
});
